import { IMdCmFields } from "../types/AppTypes";
import { MdEnableStatusEnum } from "../types/AppEnums";

//系统标识  测试和生产主数据标识区别
export const CLIENT_APP_CODE = "scm";

export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 30000;

//API请求环境
const baseRequestUrl = {
	"DEV": "http://api.peijian88.cn",
    "TEST": "https://test-api-2.laoniuche.cn",
    "PROD": "https://api-2.yunhaogroup.com",
    "STAGE": "http://api.beiben88.com",
}

//财务的请求环境
const baseFmsRequestUrl = {
	"DEV": "http://api.peijian88.cn",
    "TEST": "https://test-api-2.laoniuche.cn",
    "PROD": "https://api-2.yunhaogroup.com",
    "STAGE": "http://api.beiben88.com",
}

//鉴权的请求环境
const baseAuthRequestUrl = {
	"DEV": "http://api.peijian88.cn",
    "TEST": "https://test-api-2.laoniuche.cn",
    "PROD": "https://api-2.yunhaogroup.com",
    "STAGE": "http://api.beiben88.com",
}

//鉴权2的请求环境
const baseAuth2RequestUrl = {
	"DEV": "http://api.peijian88.cn",
    "TEST": "https://test-api-2.laoniuche.cn",
    "PROD": "https://api-2.yunhaogroup.com",
    "STAGE": "http://api.beiben88.com",
}
const baseFileRequestUrl = "http://file-server.laoniuche.cn/file";
/**
 * 上传文件路径
 */
// export const uploadFileUrl = `${baseFileRequestUrl}/uploadFile`;

// export const loadFileUrl = (id: string) => `${baseFileRequestUrl}/fetch?id=${id}`;

const baseFileUploadUrl = {
    "DEV" : "https://test.api.yunhaochefu.com/ci-file-server/upload/image_old",
    "TEST" : "https://test.api.yunhaochefu.com/ci-file-server/upload/image_old",
    "PROD" : "https://api.yunhaochefu.com/ci-file-server/upload/image_old",
}
/**
 * 上传文件路径
 */
export const uploadFileUrl =  baseFileUploadUrl[process.env.REACT_APP_ENV  as "DEV" | "TEST" | "PROD"];
/**
 * 获取文件服务器文件
 * @param id 
 * @returns 
 */
export const loadFileUrl = (id: string) => `https://file-server.yunhaochefu.com/image/${id}`;

//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
	//自动选择环境
	//....
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取请求地址
export const getBaseFmsRequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseFmsRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取鉴权请求地址
export const getBaseAuthRequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseAuthRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取鉴权请求地址
export const getBaseAuth2RequestUrl = () => {
	const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
	return baseAuth2RequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";

//获取token
export const getToken = () => {
	return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};

//存储token
export const setToken = (token: string) => {
	sessionStorage.setItem(TOKEN_KEY, token)
};
//通用字段定义
export const defaultMdCmParam: IMdCmFields = {
	sourceApp: "scm",
	sourceAuthKey: "",
	branch: "scm",
	ver: undefined,
	enable: MdEnableStatusEnum.ENABLE,
};

export const branchDs = [
	{ label: "财务分支", value: "fms" },
	{ label: "主分支", value: "main" },
	{ label: "供应链分支", value: "scm" },
]